import Axios from 'axios'
import { CHEMICALS_URL, getErrorMessage } from '@/main'

const state = {
  _chemicalsResult: { file: [], records: [] },
}

const getters = {
  chemicalsResult: (state) => {
    return state._chemicalsResult
  },
}

const mutations = {
  setChemicalsResult: (state, payload) => {
    state._chemicalsResult = payload
  },
  resetChemicalsResult: (state) => {
    state._chemicalsResult = { file: [], records: [] }
  },
}

const actions = {}

export function prepareChemicalsMetadata(context) {
  Axios.get(`${CHEMICALS_URL}/metadata`)
    .then(() => {
      context.commit('setFeatures', { chemicals: { category: 'chemicals' } })
    })
    .catch((error) => {
      console.warn('CHEMICALS module is not available: %o', getErrorMessage(error))
      context.commit('removeFeature', { chemicals: {} })
    })
}

export default {
  state,
  getters,
  mutations,
  actions,
}
